<ndt-account-detail-view
   [account]="account$ | async"
   [accountPrivileges]="accountPrivileges$ | async"
   [extensionPrivileges]="extensionPrivileges$ | async"
   [callState]="callState$ | async"
   [isSystemUser]="isSystemUser$ | async"
   [selectedAccountName]="selectedAccount$ | async"
   [isOnSystemPage]="isOnSystemPage$ | async"
   [sipDomain]="sipDomain"
   [isAdminUser]="isAdminUser$ | async"
   [idsFromRegister]="idsFromRegister$ | async"
   [totalCount]="totalCount$ | async"
   (formSaveCanceled)="onFormSaveCanceled()"
   (formSubmitted)="onFormSubmitted($event)"
   (resetMwi)="onResetMwi($event)"
   (navigateUp)="onNavigate($event)"
   (navigateDown)="onNavigate($event)"
   (loadIdPage)="onLoadIdPage()"
></ndt-account-detail-view>
